import { FA } from '@/components/common/icons/FA';
import { getColor } from '@/helpers/utils';
import { CustomIconFC } from '@/types/shared';

export const UserIcon: CustomIconFC = (props) => <FA icon="fa-user-headset" theme="far" color={getColor('user')} {...props} />;
